import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["toggle", "toggleButton", "monthlyPrice", "annualPrice", "monthlyCta", "annualCta"]
  static values = { initialAnnual: Boolean }

  connect() {
    this.isAnnual = this.initialAnnualValue || false
  }

  toggle() {
    this.isAnnual = !this.isAnnual

    // Update toggle UI with primary/accent gradient colors
    if (this.isAnnual) {
      this.toggleTarget.classList.remove('bg-secondary-300', 'hover:bg-secondary-400')
      this.toggleTarget.classList.add('bg-gradient-to-r', 'from-primary-600', 'to-accent-600')
      this.toggleButtonTarget.classList.remove('translate-x-1', 'ring-secondary-200')
      this.toggleButtonTarget.classList.add('translate-x-10', 'ring-primary-200')
      this.toggleTarget.setAttribute('aria-checked', 'true')
    } else {
      this.toggleTarget.classList.remove('bg-gradient-to-r', 'from-primary-600', 'to-accent-600')
      this.toggleTarget.classList.add('bg-secondary-300', 'hover:bg-secondary-400')
      this.toggleButtonTarget.classList.remove('translate-x-10', 'ring-primary-200')
      this.toggleButtonTarget.classList.add('translate-x-1', 'ring-secondary-200')
      this.toggleTarget.setAttribute('aria-checked', 'false')
    }

    // Toggle pricing display for all cards
    this.monthlyPriceTargets.forEach(el => {
      el.classList.toggle('hidden', this.isAnnual)
    })
    this.annualPriceTargets.forEach(el => {
      el.classList.toggle('hidden', !this.isAnnual)
    })
    this.monthlyCtaTargets.forEach(el => {
      el.classList.toggle('hidden', this.isAnnual)
    })
    this.annualCtaTargets.forEach(el => {
      el.classList.toggle('hidden', !this.isAnnual)
    })
  }
}
